import { millify } from 'millify';
import { Decimal } from 'decimal.js';

const NumberFormaters = {
  MILLIFY: (num: Decimal) => {
    return millify(num.toNumber());
  },
  DECIMAL: (num: Decimal) => {
    return new Intl.NumberFormat('en-US').format(num.toNumber());
  }
} as const;

const numberFormat = (
  num: Decimal | number | string | null | undefined,
  format: keyof typeof NumberFormaters = 'MILLIFY',
  scale = 0
) => {
  if (num === null || num === undefined) {
    return null;
  }

  const number = new Decimal(num).div(Decimal.pow(10, scale));
  return NumberFormaters[format](number);
};

const currencyFormat = (
  currency: string,
  num: Decimal | number | string | null | undefined,
  format: keyof typeof NumberFormaters = 'MILLIFY',
  scale = 0
) => {
  if (num === null || num === undefined) {
    return null;
  }

  return `${numberFormat(num, format, scale)} ${currency}`;
};

export { NumberFormaters, numberFormat, currencyFormat };
